import React from "react";

import speechBubbles from "static/svg/speech-bubbles.svg";
import leaveGame from "static/svg/leave-game.svg";
import { FormattedMessage } from "react-intl";

export default class InstructionScreen extends React.Component {
  render() {
    let { groups } = this.props.information.data;
    let { data } = this.props.information;
    return (
      <div className="app-container">
        <div className="container-fluid player-container">
          <span className="exit-button" onClick={() => this.props.exitGame()}>
            <FormattedMessage id="app.exitgame">
              {(msg) => (
                <img
                  style={{ width: "100%", height: "100%" }}
                  alt={msg}
                  src={leaveGame}
                />
              )}
            </FormattedMessage>
          </span>
          <div className="row">
            <div className="col-md">
              <p className="app-paragraph" style={{ textAlign: "right" }}></p>
            </div>
          </div>
          <div className="row">
            <div
              className="title-container col-md"
              style={{ paddingTop: 0, marginBottom: 0 }}
            ></div>
          </div>
          <div className="row">
            <FormattedMessage id="app.speechbubbles">
              {(msg) => (
                <img
                  className="hourglass"
                  style={{ marginTop: "25%", marginBottom: "25%" }}
                  src={speechBubbles}
                  alt={msg}
                />
              )}
            </FormattedMessage>
          </div>
          <div className="row">
            <div className="d-flex justify-content-center col-md"></div>
          </div>
        </div>
      </div>
    );
  }
}
